/**
 * Normalize API `signups` (JSON string, array, or null) to millisecond timestamps.
 */
export function getSignupsTimestamps(signups: unknown): number[] {
  if (signups == null) return [];
  if (Array.isArray(signups)) {
    return signups.map((n) => Number(n)).filter((n) => !Number.isNaN(n));
  }
  if (typeof signups === "string") {
    try {
      const p = JSON.parse(signups);
      return Array.isArray(p)
        ? p.map((n) => Number(n)).filter((n) => !Number.isNaN(n))
        : [];
    } catch {
      return [];
    }
  }
  return [];
}

/**
 * "New" = at most one signup event in history; "Repeat" = two or more.
 * Matches waitlist name column badge logic (avoids min(signups) vs signup_date drift).
 */
export function isNewSignupEvent(signups: unknown): boolean {
  return getSignupsTimestamps(signups).length <= 1;
}
